import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@nebula-shared/data-access';

@Component({
  selector: 'app-divider-section',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './divider-section.component.html',
  styleUrls: ['./divider-section.component.scss'],
})
export class DividerSectionComponent {
  @Input() title = '';
  @Input() borderColor = 'var(--color-heading)';
  @Input() borderWidth = '1px';
  @Input() paddingBottom = '4px';
  @Input() fontSize = '0.8125rem';
  @Input() fontWeight = '700';
  @Input() textAlign = 'left';
  @Input() marginTop = '0';
  @Input() marginBottom = '1rem';
  @Input() fullWidth = true;
  @Input() showDivider = true;
  @Input() titleColor = 'var(--color-subtitle)';
}
